import { store } from "../../store";

export const normalizeData = (data, storageType) =>
  data
    .map(
      ({
        location,
        lpn,
        sku,
        qualityStatus,
        latitude,
        longitude,
        positionLength,
        locationOrientation
      }) => ({
        location,
        lpn,
        sku,
        qualityStatus,
        storageType,
        locationOrientation,
        positionLength,
        ...(latitude && longitude ? { latitude, longitude } : {})
      })
    )
    .sort();

const transformVehicleNumer = (vehicleNumber) => {
  const padded = String(vehicleNumber).padStart(2, "0");
  return `LGV_${padded}`;
};

export const deTransformLGVName = (str) => {
  if (typeof str !== "string" || !str.startsWith("LGV_")) return null;
  const numPart = str.split("_")[1];
  const parsed = parseInt(numPart, 10);
  return isNaN(parsed) ? null : String(parsed);
};

export const normalizeLGVData = (rawData) => {
  const data = [...rawData];
  return data
    .sort((a, b) => Number(a.vehicleNumber) - Number(b.vehicleNumber))
    .map(({ vehicleNumber }) => ({
      location: transformVehicleNumer(vehicleNumber),
      storageType: "lgv"
    }));
};

export const filterDuplicates = (data, key) => {
  const uniqueValues = new Set();
  data.forEach((item) => {
    if (item[key]) {
      uniqueValues.add(item[key]);
    }
  });
  return Array.from(uniqueValues);
};

export const matches = (
  item,
  { selectedLPN, selectedLocation, selectedSKU, selectedQualityStatus }
) => {
  if (selectedLocation && item.location !== selectedLocation) return false;
  if (selectedSKU && item.sku !== selectedSKU) return false;
  if (selectedLPN && !item.lpn?.includes(selectedLPN)) return false; //lpn can be full or partially provided
  if (selectedQualityStatus && item.qualityStatus !== selectedQualityStatus)
    return false;

  return true;
};

export const isFiltersEnabled = () => {
  const state = store.getState();

  const {
    location: selectedLocation,
    sku: selectedSKU,
    lpn: selectedLPN,
    qualityStatus: selectedQualityStatus
  } = state.inventory.filters;

  return (
    selectedLocation || selectedLPN || selectedSKU || selectedQualityStatus
  );
};

export const highlight = (levelLocations) => {
  const {
    inventory: { results, containsBlockRackNonLGV, filters, selectedResult }
  } = store.getState();

  if (
    results.length &&
    Array.isArray(levelLocations) &&
    isFiltersEnabled() &&
    containsBlockRackNonLGV
  ) {
    const {
      location: selectedLocation,
      sku: selectedSKU,
      lpn: selectedLPN,
      qualityStatus: selectedQualityStatus
    } = filters;

    for (const item of levelLocations) {
      if (
        matches(item, {
          selectedLocation,
          selectedLPN,
          selectedQualityStatus,
          selectedSKU
        })
      ) {
        return selectedResult?.location === item?.location
          ? " highlighter"
          : "";
      }
    }

    return " gray-out";
  }

  return "";
};
